import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import GraphEditor from "./GraphEditor";

// import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

ReactDOM.render(
/*   <React.StrictMode>
    <App />
    <MyMxGraph />
  </React.StrictMode>, */
    <React.StrictMode>
      <GraphEditor />
    </React.StrictMode>,
    document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
